import axios from "axios";

// An empty value intentionally uses the same-origin reverse proxy (local
// Compose and static smoke tests). Deployed builds must provide the HTTPS API
// origin through REACT_APP_BACKEND_URL.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api/v1`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("eduos_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("eduos_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const unwrap = (res) => res.data?.data ?? res.data;

// Convenience: extract error message from a caught Axios error
export const errMsg = (e) => {
  const d = e?.response?.data?.detail || e?.response?.data;
  if (typeof d === "string") return d;
  return d?.error?.message || d?.message || e?.message || "Something went wrong";
};

export const listPlatformConfiguration = async () =>
  unwrap(await api.get("/platform/configuration"));

export const getPlatformConfiguration = async (key) =>
  unwrap(await api.get(`/platform/configuration/${encodeURIComponent(key)}`));

export const upsertPlatformConfiguration = async (key, value) =>
  unwrap(
    await api.put(`/platform/configuration/${encodeURIComponent(key)}`, {
      value,
    })
  );

export const clearPlatformConfigurationCache = async (key = null) =>
  unwrap(await api.post("/platform/cache/clear", { key }));

export const getPublicBranding = async () =>
  unwrap(await api.get("/public/branding"));

export const getPlatformBranding = async () =>
  unwrap(await api.get("/platform/branding"));

export const updatePlatformBranding = async (payload) =>
  unwrap(await api.put("/platform/branding", payload));

export const listPlatformLookups = async () =>
  unwrap(await api.get("/platform/lookups"));

export const getPlatformLookup = async (key) =>
  unwrap(await api.get(`/platform/lookups/${encodeURIComponent(key)}`));

export const upsertPlatformLookup = async (key, payload) =>
  unwrap(
    await api.put(`/platform/lookups/${encodeURIComponent(key)}`, payload)
  );

export const clearLookupCache = async (key = null) =>
  unwrap(await api.post("/platform/lookups/cache/clear", { key }));

export const getLookupValues = async (key, includeInactive = false) =>
  unwrap(
    await api.get(`/lookups/${encodeURIComponent(key)}`, {
      params: { include_inactive: includeInactive },
    })
  );
